import React from 'react';
import './portfolio.css';
import PairaImage from '../../assets/PairaImage.jpeg';
import PairaAPI from '../../assets/PairaAPI.png';

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>Earlier technical work</h5>
      <h2>Selected Projects</h2>
      <p className='portfolio_intro'>
        Product and API work from before my security role. Useful context for how I build internal tools and automate messy processes.
      </p>

      <div className='container portfolio_container'>
        <article className='portfolio_item'>
          <div className='portfolio_item-image'>
            <img src={PairaImage} alt='Paira mobile app'/>
          </div>
          <h3>Paira — iOS &amp; Android app</h3>
          <p className='portfolio_item-copy'>
            React Native client with a Node.js backend. Auth, APIs, and CI/CD — the same building blocks I now use for analyst tooling.
          </p>
          <div className='portfolio_item-cta'>
            <a href='https://github.com/d-willie01/Paira/tree/master/ui/v1' className='btn' target="_blank" rel="noopener noreferrer">GitHub</a>
            <a href='https://www.paira.info/' className='btn btn-primary' target="_blank" rel="noopener noreferrer">Landing Page</a>
          </div>
        </article>

        <article className='portfolio_item'>
          <div className='portfolio_item-image'>
            <img src={PairaAPI} alt='Paira API architecture'/>
          </div>
          <h3>Paira API on Azure</h3>
          <p className='portfolio_item-copy'>
            TypeScript API hosted on Azure with Docker, blob storage, and MongoDB.
          </p>
          <div className='portfolio_item-cta'>
            <a href='https://github.com/d-willie01/Paira/tree/master/api/v1' className='btn' target="_blank" rel="noopener noreferrer">GitHub</a>
          </div>
        </article>
      </div>
    </section>
  )
}

export default Portfolio
